import { takeEvery, put, call } from 'redux-saga/effects';
import { GET_LOST_ORDERS } from './actionTypes';
import { getLostOrdersSuccess, getLostOrdersFail, showLoading, hideLoading } from './actions';
import { getLostOrdersInfo } from "../../helpers/backend_helper"

/*NOT SOCKET CONNECTION*/
function* fetchLostOrdersInfo() {
  try {
    yield put(showLoading(true))
    const response = yield call(getLostOrdersInfo)
    yield put(getLostOrdersSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(showLoading(true))
    yield put(getLostOrdersFail(error))
  }
}
/*NOT SOCKET CONNECTION*/

function* lostOrdersSaga() {
  yield takeEvery(GET_LOST_ORDERS, fetchLostOrdersInfo)
}

export default lostOrdersSaga;